import { useState, useEffect, useCallback } from 'react';

const useResponsiveModal = (initialWidthPercentage = 0.8, initialHeightPercentage = 0.8, minWidth = 900, maxWidth = 1800, minHeightRatio = 0.64) => {
  const maxHeight = maxWidth * minHeightRatio;
  const minHeight = minWidth * minHeightRatio;

  const [dimensions, setDimensions] = useState({
    x: '100px',
    y: '100px',
    width: `${window.innerWidth * initialWidthPercentage}px`,
    height: `${window.innerHeight * initialHeightPercentage}px`
  });

  const onWindowResize = useCallback(() => {
    const windowWidth = window.innerWidth - 150;
    const windowHeight = window.innerHeight - 75;

    const availableWidth = Math.max(minWidth, Math.min(windowWidth, maxWidth));
    const availableHeight = Math.max(minHeight, Math.min(windowHeight, maxHeight));

    const ratioWidth = availableHeight / minHeightRatio;
    const ratioHeight = availableWidth * minHeightRatio;

    // Determine if we need to scale based on width or height by comparing the calculated heights to the available height
    const scaleOnWidth = ratioHeight <= availableHeight;

    const width = scaleOnWidth ? availableWidth : ratioWidth;
    const height = scaleOnWidth ? ratioHeight : availableHeight;

    const xPosition = (window.innerWidth - width) / 2;
    const yPosition = (window.innerHeight - height) / 4;

    setDimensions({
      width: `${width}px`,
      height: `${height}px`,
      x: `${xPosition}px`,
      y: `${yPosition}px`
    });

  }, [maxWidth, minWidth, minHeightRatio, maxHeight, minHeight]);

  useEffect(() => {
    onWindowResize();
    window.addEventListener('resize', onWindowResize);

    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  }, [onWindowResize]);

  return dimensions;
};

export default useResponsiveModal;
